import { forwardRef } from 'react';
import { ChildrenProps, classNames } from '@cotera/client/app/components/utils';

export const Caption = forwardRef<
  HTMLParagraphElement,
  ChildrenProps & {
    className?: string;
    onClick?: () => void;
    style?: React.CSSProperties;
  }
>(({ children, className, onClick, style }, ref) => {
  return (
    <p
      onClick={onClick}
      style={style}
      ref={ref}
      className={classNames('text-muted-foreground', 'text-sm', className)}
    >
      {children}
    </p>
  );
});
